export const REFERRAL_SERIES_DROPDOWN = [
  { key: 'google', label: 'Google/Internet' },
  { key: 'wordOfMouth', label: 'Word of Mouth' },
  { key: 'pcp', label: 'PCP' },
  { key: 'socialMedia', label: 'Social Media' },
  { key: 'therapist', label: 'Counselor' },
  { key: 'hospital', label: 'Hospital/ER' },
  { key: 'insurance', label: 'Insurance' },
  { key: 'school', label: 'School' },
  { key: 'aiTools', label: 'AI Tools' },
  { key: 'other', label: 'Other' },
  { key: 'migrated', label: 'Existing Patient' },
  { key: 'accountmgnt', label: 'Account Transfer' },
  { key: 'onlinevideo', label: 'Online Video' },
  
];
export const REFERRAL_KEY_MAP: Record<string, string> = {
  'Google/Internet': 'google',
  'Word of Mouth': 'wordOfMouth',
  'PCP': 'pcp',
  'Social Media': 'socialMedia',
  'Counselor': 'therapist',
  'Hospital': 'hospital',
  'Insurance': 'insurance',
  'School': 'school',
  'AI Tools': 'aiTools',
  'Other':'other',
  'Existing Patient':'migrated',
  'Account Transfer':'accountmgnt',
  'Online Video' : 'onlinevideo',
};

export const SOURCE_COLORS = [
  '#0D47A1', // Google / Internet Search (Deep Navy)
  '#2E7D32', // Word of Mouth (Forest Green)
  '#FF6F00', // PCP / Physician (Amber)
  '#6A1B9A', // Social Media (Dark Violet)
  '#283593', // Counselor (Royal Indigo)
  '#BF360C', // Hospital / ER (Burnt Orange)
  '#00695C', // Insurance (Dark Teal)
  '#C62828', // School (Crimson)
  '#AD1457', // AI Tools (Wine Pink)
  '#4E342E', // Other (Dark Coffee)
  '#607D8B', // Migrated (Steel Grey)
  '#455A64', // Account Transfer (Slate Blue Grey)
  '#00838F', // Online Video (Cyan Teal)
];


